module.exports = __webpack_public_path__ + "img/ED-PROJECAO.41e1ee70.jpg";